export class UpdateIntegrationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "config",
            "baseName": "config",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIntegrationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
